"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationType = void 0;
var NotificationType;
(function (NotificationType) {
    NotificationType["ACTION_PRIMARY"] = "action-primary";
    NotificationType["ACTION_SECONDARY"] = "action-secondary";
    NotificationType["INFORMATION"] = "information";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
